$easyreels_user_notify $mol_view
	uri \
	sub /
		<= Link $mol_link
			uri <= uri
			target \_blank
			sub /
				<= Icon $mol_icon_bell
				<= Link_title $mol_view
					sub /
						<= link_title @ \Get Telegram notifications
		<= Hint $mol_paragraph
			title @ \The bot can write to you only after you press Start in it.
